import React, {useState} from "react";
import {Box, Typography} from "@mui/material";
import IconWrapper from "components/IconWrapper";
import DefaultLayout from "layout/defaultLayout";
import AIConnectIcon from "assets/images/IconAiConnectBig.svg";
import "./SignUpAIConnectPage.scss";
import SignUpFormAIConnect from "../../../features/product-sign-up/SignUpFormAIConnect";
import CustomButtonWithIcon from "../../../components/CustomButtonWithIcon/Buttons";

const SignUpAIConnectPage = () => {
    const [isPanelOpen, setPanelOpen] = useState(false);
    const togglePanel = () => {
        setPanelOpen((prev) => !prev);
    };

    return (
        <DefaultLayout page="AI Connect">
            <Box className="aiConnectSignUpPage">
                <div className="header-container">
                    <div>
                        <div className="header-left">
                            <div className="icon-wrapper">
                                <IconWrapper icon={AIConnectIcon} />
                            </div>
                            <div>
                                <Typography className="quency-cf-normal heading">
                                    AI Connect
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="summary-section">
                    <Typography variant="body1" className="summary-text">
                        <p className="summary-text-bold">
                            Be discoverable on AI platforms
                        </p>
                        With 40% of global travelers have already used AI-based tools like
                        ChatGPT, Claude, and Gemini to plan their trips, your hotel needs
                        to be part of the conversation. AI Connect pushes your live rates
                        and availability directly into traveler journeys, reclaiming
                        visibility from OTAs and showcasing authentic hotel-direct
                        listings to ensure guests see accurate pricing and availability.
                        <br />
                        <br />
                        <p className="summary-text-bold">
                            Ready to future-proof your hotel visibility?
                        </p>
                        Join the next generation of hotels increasing their
                        discoverability through AI-powered channels.
                    </Typography>

                    <CustomButtonWithIcon
                        onClick={togglePanel}
                        color="#b0acac"
                        hoverColor="#61D5A9"
                        width="201px"
                        height="44px"
                        titleColor="#373F41"
                        borderRadius="20px"
                        title="Request a Demo"
                        iconBorder="0.5px solid #373F41"
                        textStyle={{
                            display:'flex',
                            fontFamily: 'Inter',
                            fontSize: '12px',
                            fontWeight: 500,
                            lineHeight: '14.52px',
                            textAlign: 'center'
                        }}
                    >
                        Request a Demo
                    </CustomButtonWithIcon>
                </div>
            </Box>
            <SignUpFormAIConnect isOpen={isPanelOpen} onClose={togglePanel} />
        </DefaultLayout>
    );
};
export default SignUpAIConnectPage;
